import { maybeCsrfFix } from "./maybeCsrfFix";

const POPUP_WINDOW_OPTIONS =
  "height=700,width=980,scrollbars=yes,resizable=yes,status=yes,menubar=no,toolbar=no,location=no";

// Create the popup window and return the new window object ref.
// If the window cannot be created (is blocked) then null is returned.
// See https://developer.mozilla.org/en-US/docs/Web/API/Window/open#Return_value
export const createPopupWindow = (url: string) => {
  // Use unique window name to prevent browser from reusing tabs
  const windowName = `zapier-auth-popup-${Date.now()}`;
  // Apply CSRF fix for Safari compatibility
  const maybeFixedUrl = maybeCsrfFix(url);
  return window.open(maybeFixedUrl, windowName, POPUP_WINDOW_OPTIONS);
};

export const createConnectPopup = (url: string): Window => {
  const popup = createPopupWindow(url);

  // When popups are blocked by the browser `popup` will be falsey
  // so we return early here.
  if (!popup) {
    const errorMessage = `
Popup blocked! To connect your account:

1. Click the popup blocker icon in your browser's address bar
2. Choose "Always allow popups from zapier.com" 
3. Try connecting again

Or try opening in the same window:
${url}
    `.trim();

    throw new Error(errorMessage);
  }

  // Additional check: some browsers return a popup object but don't actually open it
  // This can happen with strict popup blockers
  setTimeout(() => {
    try {
      if (popup.closed) {
        // Popup was closed immediately - likely blocked
        // eslint-disable-next-line no-console
        console.warn(
          "[AUTH] Popup may have been blocked - window closed immediately",
        );
      }
    } catch {
      // Cross-origin error accessing popup.closed is normal and expected
      // This actually indicates the popup opened successfully
    }
  }, 100);

  return popup;
};
